import { createTheme } from '@mui/material/styles'
import { FontSize } from 'mui-tiptap';

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#000'
    },
    customColor: {
      default: "#222",
      cardBorderColor: "rgba(52, 52, 52, .67) !important",
      cardActive: 'rgba(72, 72, 72, .3)',
      editorBG: '#222',
      cardBg: '#1d1d1d',
      textDark: '#fff',
      timeBg: '#2c2c2c',
      blueColor: '#0858d5'
    },
    chatColor: {
      chatRightBg: '#005c4b',
      chatLeftBg: '#222'
    },
    copyBtn: {
      copyBg: '#222',
      copyText: '#fff'
    }
  },
  typography: {
    // fontSize: '1.4rem',
    htmlFontSize: 11,
  },
});